module.exports = __webpack_public_path__ + "img/2.023c45af.jpg";